// Partner Credential Types
// These define what inputs are needed for each partner

//import { BetOpenlyCredentialProps as BetOpenlyCredentialPropsImport } from "../partners/betopenly/cred.types"

// Re-export BetOpenly credentials
export type BetOpenlyCredentialProps = any

export interface KalshiCredentialProps {
    api_key: string
    private_key_pem: string
}

export interface BettorEdgeCredentialProps {
    username: string
    password: string
    access_token?: string // We will store the bearer token here
    refresh_token?: string // Store the refresh token here
    expire_datetime?: any // timestamp with timezone
}

// Union type of all possible credentials
export type PartnerCredentialProps = KalshiCredentialProps | BettorEdgeCredentialProps | BetOpenlyCredentialProps

// Type guard helpers for client to determine which credential type is needed
export const isKalshiCredentials = (creds: any): creds is KalshiCredentialProps => {
    return 'api_key' in creds && 'private_key_pem' in creds
}

export const isBettorEdgeCredentials = (creds: any): creds is BettorEdgeCredentialProps => {
    return 'username' in creds && 'password' in creds && 'device_id' in creds
}

export const isBetOpenlyCredentials = (creds: any): creds is BetOpenlyCredentialProps => {
    return 'username' in creds && 'password' in creds && !('device_id' in creds)
}

// Helper to get required fields for a partner by name
export const getRequiredCredentialFields = (partnerName: string): string[] => {
    switch (partnerName) {
        case 'Kalshi':
            return ['api_key', 'private_key_pem']
        case 'BettorEdge':
            return ['username', 'password']
        case 'BetOpenly':
            return ['user_id','username', 'password']
        default:
            return []
    }
}

// Helper to get credential field labels for UI
export const getCredentialFieldLabels = (partnerName: string): Record<string, string> => {
    switch (partnerName) {
        case 'Kalshi':
            return {
                api_key: 'API Key',
                private_key_pem: 'Private Key (PEM format)'
            }
        case 'BettorEdge':
            return {
                username: 'Username',
                password: 'Password'
            }
        case 'BetOpenly':
            return {
                username: 'Username',
                password: 'Password',
                user_id: 'User Id'
            }
        default:
            return {}
    }
}

// Helper to get credential field types for UI
export const getCredentialFieldTypes = (partnerName: string): Record<string, 'text' | 'password' | 'textarea'> => {
    switch (partnerName) {
        case 'Kalshi':
            return {
                api_key: 'text',
                private_key_pem: 'textarea'
            }
        case 'BettorEdge':
            return {
                username: 'text',
                password: 'password',
            }
        case 'BetOpenly':
            return {
                user_id: 'text',
                username: 'text',
                password: 'password'
            }
        default:
            return {}
    }
}
